import { render, staticRenderFns } from "./QuickAddTaskClient.vue?vue&type=template&id=2ef1c016&"
import script from "./QuickAddTaskClient.vue?vue&type=script&lang=ts&"
export * from "./QuickAddTaskClient.vue?vue&type=script&lang=ts&"
import style0 from "./QuickAddTaskClient.vue?vue&type=style&index=0&id=2ef1c016&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports